// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  height: 100%;
}
.sidebar .item-router {
  text-decoration: none;
}

.brand-logo:hover {
  text-decoration: none;
}
.brand-logo .brand-icon {
  display: flex;
  justify-content: center;
  height: 60px;
}
.brand-logo .brand-icon img {
  width: 190px;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/sidebar/sidebar.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAAE;EACE,qBAAA;AAEJ;;AAGE;EACE,qBAAA;AAAJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AAAJ;AACI;EACE,YAAA;AACN","sourcesContent":[".sidebar {\r\n  height: 100%;\r\n  .item-router {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n.brand-logo {\r\n  &:hover {\r\n    text-decoration: none;\r\n  }\r\n  .brand-icon {\r\n    display: flex;\r\n    justify-content: center;\r\n    height: 60px;\r\n    img {\r\n      width: 190px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
